import { useStore } from "@/core/services/store";
import { setXentralConfig } from "@/composables/useSalesChannelManagementApp";
import { useRoute } from "vue-router/composables";
import { baseUrl } from "@/components/ExternalApps/SalesChannelManagementApp/config/apps/molliePosApp";

export const useMolliePosOauth = () => {
  const store = useStore();
  const route = useRoute();

  async function getAccessToken() {
    const state = store.getters.migrationOAuthState;
    const xentralConfig = store.getters.xentralConfig?.data;
    const fromUrl = xentralConfig?.baseUrl?.replace(/\/$/, "") || "";
    const endpoint = xentralConfig?.xentralAppUri || "";

    // Update state
    Object.assign(state, {
      from_url: `${fromUrl.replace(/\/+$/, "")}/${endpoint.replace(
        /^\/+/,
        ""
      )}`,
      redirect_uri: process.env.VUE_APP_MOLLIE_APP_REDIRECT_URL,
      licenseId: store.getters.licenseId,
      origin: route.params?.area,
      isMigration: true,
      project_id: store.getters?.selectedIntegration?.id
    });

    // Construct the OAuth URL
    const params = new URLSearchParams({
      client_id: process.env.VUE_APP_MOLLIE_APP_CLIENT_ID,
      redirect_uri: process.env.VUE_APP_MOLLIE_APP_REDIRECT_URL,
      state: btoa(JSON.stringify(state))
    });

    resetXentralConfig();

    // Redirect to the OAuth URL
    window.open(`${baseUrl}?${params}`, "_parent");
  }

  function resetXentralConfig() {
    //Remove state property from xentralConfig vuex store
    let xentralData = store.getters.xentralConfig;

    // Create a new object excluding the 'state' property
    let newData = { ...xentralData.data };
    delete newData.state;

    let updatedXentralConfig = { ...xentralData, data: newData };

    setXentralConfig(updatedXentralConfig);
  }

  return {
    getAccessToken
  };
};
